import faqUrl from '@/utils/urls/faqUrl';

import {
    url_faq_add_social_profile,
    url_faq_autopost_stories,
    url_faq_collaboration,
    url_faq_create_album,
    url_faq_create_captions_ai,
    url_faq_create_dashboard,
    url_faq_create_save_captions_hashtags,
    url_faq_invite_user,
    url_faq_label_media_library,
    url_faq_schedule_reports
} from '@/lib/urls/faqUrls';

export const CATEGORY_CONTENT = 'content';
export const CATEGORY_PUBLISHING = 'publishing';
export const CATEGORY_REPORT = 'report';
export const CATEGORY_DASHBOARD = 'dashboard';
export const CATEGORY_SETTINGS = 'settings';

// Images
// Types
import type { StaticImageData } from 'next/image';

import Charles from '@public/images/home/faqAuthors/charles.png';
import Cordelia from '@public/images/home/faqAuthors/cordelia.png';
import Pamela from '@public/images/home/faqAuthors/pamela.png';

export type FAQCategoryType =
    | typeof CATEGORY_CONTENT
    | typeof CATEGORY_PUBLISHING
    | typeof CATEGORY_REPORT
    | typeof CATEGORY_DASHBOARD
    | typeof CATEGORY_SETTINGS;

export type FAQArticleType = {
    id: number;
    author: string;
    authorPhoto: StaticImageData;
    title: string;
    text: string;
    link: string;
    category: FAQCategoryType;
};

export const FAQList: FAQArticleType[] = [
    {
        id: 1,
        author: 'Cordelia',
        authorPhoto: Cordelia,
        title: 'faq.title_1',
        text: 'faq.text_1',
        link: faqUrl(url_faq_label_media_library),
        category: CATEGORY_CONTENT
    },
    {
        id: 2,
        author: 'Cordelia',
        authorPhoto: Cordelia,
        title: 'faq.title_2',
        text: 'faq.text_2',
        link: faqUrl(url_faq_create_album),
        category: CATEGORY_CONTENT
    },
    {
        id: 3,
        author: 'Charles',
        authorPhoto: Charles,
        title: 'faq.title_3',
        text: 'faq.text_3',
        link: faqUrl(url_faq_autopost_stories),
        category: CATEGORY_PUBLISHING
    },
    {
        id: 4,
        author: 'Cordelia',
        authorPhoto: Cordelia,
        title: 'faq.title_4',
        text: 'faq.text_4',
        link: faqUrl(url_faq_collaboration),
        category: CATEGORY_PUBLISHING
    },
    {
        id: 5,
        author: 'Cordelia',
        authorPhoto: Cordelia,
        title: 'faq.title_5',
        text: 'faq.text_5',
        link: faqUrl(url_faq_create_save_captions_hashtags),
        category: CATEGORY_PUBLISHING
    },
    {
        id: 6,
        author: 'Charles',
        authorPhoto: Charles,
        title: 'faq.title_6',
        text: 'faq.text_6',
        link: faqUrl(url_faq_create_captions_ai),
        category: CATEGORY_PUBLISHING
    },
    {
        id: 7,
        author: 'Pamela',
        authorPhoto: Pamela,
        title: 'faq.title_7',
        text: 'faq.text_7',
        link: faqUrl(url_faq_schedule_reports),
        category: CATEGORY_REPORT
    },
    {
        id: 8,
        author: 'Pamela',
        authorPhoto: Pamela,
        title: 'faq.title_8',
        text: 'faq.text_8',
        link: faqUrl(url_faq_create_dashboard),
        category: CATEGORY_DASHBOARD
    },
    {
        id: 9,
        author: 'Pamela',
        authorPhoto: Pamela,
        title: 'faq.title_9',
        text: 'faq.text_9',
        link: faqUrl(url_faq_invite_user),
        category: CATEGORY_SETTINGS
    },
    {
        id: 10,
        author: 'Pamela',
        authorPhoto: Pamela,
        title: 'faq.title_10',
        text: 'faq.text_10',
        link: faqUrl(url_faq_add_social_profile),
        category: CATEGORY_SETTINGS
    }
];
